import {
    Box,
    Button,
    Flex,
    Icon,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";

import { FiAlertCircle } from "react-icons/fi";
import moment from "moment";
import { FaCircle } from "react-icons/fa";
import { isMetaProperty } from "typescript";
import { dateForListWithHours } from "../../../../constants/dataFormat";
import { useRecoilState } from "recoil";
import { GRAY, VARIANT, WHITE } from "../../../../constants/colors";

export default function DetailsPixDireto({ isOpen, setIsOpen, item }: any) {
    const finalRef = React.useRef(null);
    const navigate = useNavigate();

    const onClose = () => {
        setIsOpen(false);
    };

    return (
        <>
            <Modal
                finalFocusRef={finalRef}
                isOpen={isOpen}
                onClose={onClose}
                size={"5xl"}
            >
                <ModalOverlay backdropFilter="blur(10px)" />
                <ModalContent>
                    <ModalHeader>
                        <Flex w={"100%"} justifyContent={"center"}>
                            <Text fontWeight={"bold"}>
                                Detalhes da Solicitação de Pagamento
                            </Text>
                        </Flex>
                    </ModalHeader>
                    {item && (
                        <ModalBody>
                            <Flex
                                w={"100%"}
                                alignItems={"flex-start"}
                                minHeight={"250px"}
                                height={"fit-content"}
                                border={"2px solid #c4c4c4"}
                                justifyContent={"space-evenly"}
                                shadow={"md"}
                                borderRadius={"6px"}
                            >
                                <TableContainer w={"100%"}>
                                    <Table variant={"striped"} w={"100%"}>
                                        <Thead position="sticky" top="0">
                                            <Tr>
                                                <Th bgColor={VARIANT} color={WHITE}>
                                                    Data
                                                </Th>
                                                <Th bgColor={VARIANT} color={WHITE}>
                                                    Status
                                                </Th>
                                                <Th bgColor={VARIANT} color={WHITE}>
                                                    Observação
                                                </Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {item.map((i: any) => {
                                                return (
                                                    <Tr key={i.id}>
                                                        <Td fontSize={"14px"}>
                                                            {moment(i.data ? i.data : null).format(
                                                                dateForListWithHours
                                                            )}
                                                        </Td>
                                                        <Td fontSize={"14px"}>
                                                            {i.transacaoStatus?.status
                                                                ? i.transacaoStatus.status
                                                                : null}
                                                        </Td>
                                                        <Td
                                                            fontSize={"14px"}
                                                            maxWidth={"300px"}
                                                            whiteSpace={"pre-wrap"}
                                                        >
                                                            {i.status ? i.status : null}
                                                        </Td>
                                                    </Tr>
                                                );
                                            })}
                                        </Tbody>
                                    </Table>
                                </TableContainer>
                            </Flex>
                        </ModalBody>
                    )}
                    <ModalFooter justifyContent={"space-evenly"}>
                        <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
                            Fechar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}
